import React, { useState } from 'react';
import LegalCaseForm from '../components/Legal/LegalCaseForm';
import LegalResultsDisplay from '../components/Legal/LegalResultsDisplay';

const LegalPage = ({ apiUrl }) => {
  const [analysisResult, setAnalysisResult] = useState(null);
  const [lastCaseData, setLastCaseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAnalysisComplete = (result, caseData) => {
    let finalResult = result;
    if (result && result.success && result.data) {
      finalResult = result.data;
    } else if (result && result.data) {
      finalResult = result.data;
    }
    setAnalysisResult(finalResult);
    setLastCaseData(caseData || null);
  };

  return (
    <div className="content-grid">
      <div className="form-section">
        <LegalCaseForm
          onAnalysisComplete={handleAnalysisComplete}
          onError={setError}
          setLoading={setLoading}
          apiUrl={apiUrl}
        />
      </div>
      <div className="results-section">
        {error && <div className="error-message">❌ {error}</div>}
        {loading && <div className="loading">Analyzing case...</div>}
        {analysisResult && (
          <LegalResultsDisplay
            result={analysisResult}
            apiUrl={apiUrl}
            caseData={lastCaseData}
          />
        )}
        {!analysisResult && !error && !loading && (
          <div className="placeholder">
            <h3>⚖️ Case Assessment Results</h3>
            <p>Submit a case to see AI analysis results here.</p>
            <div className="placeholder-demo">
              <p>The analysis will include:</p>
              <ul>
                <li>Clear case summary</li>
                <li>Relevant laws and sections</li>
                <li>Suggested next steps</li>
                <li>Plain-language explanations</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LegalPage;